/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateHarvestContributionDto,
  CreateHarvestDto,
  HarvestContributionDto,
  HarvestContributionListDto,
  HarvestDto,
  HarvestEarningsDto,
  HarvestListDto,
  HarvestPhotoDto,
  HarvestPhotoListDto,
  HarvestSummaryDto,
  HarvestsControllerListContributionsParams,
  HarvestsControllerListParams,
  PatchHarvestStatusDto,
  RecordSaleDto,
  UploadHarvestPhotoDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * owner_user_id is the JWT sub. Initial status=open, total_kg=0. Optional free-text note.
 * @summary Open a new individual harvest owned by the caller
 */
export const harvestsControllerCreate = (
    createHarvestDto: CreateHarvestDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<HarvestDto>(
      {url: `/harvests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createHarvestDto, signal
    },
      );
    }
  


export const getHarvestsControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerCreate>>, TError,{data: CreateHarvestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerCreate>>, TError,{data: CreateHarvestDto}, TContext> => {

const mutationKey = ['harvestsControllerCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof harvestsControllerCreate>>, {data: CreateHarvestDto}> = (props) => {
          const {data} = props ?? {};

          return  harvestsControllerCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HarvestsControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof harvestsControllerCreate>>>
    export type HarvestsControllerCreateMutationBody = CreateHarvestDto
    export type HarvestsControllerCreateMutationError = unknown

    /**
 * @summary Open a new individual harvest owned by the caller
 */
export const useHarvestsControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerCreate>>, TError,{data: CreateHarvestDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof harvestsControllerCreate>>,
        TError,
        {data: CreateHarvestDto},
        TContext
      > => {

      const mutationOptions = getHarvestsControllerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Always filtered to owner_user_id = caller. Optional status filter. Order: most recent opened first.
 * @summary List the caller's own harvests (paginated, owner-scoped)
 */
export const harvestsControllerList = (
    params?: HarvestsControllerListParams,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<HarvestListDto>(
      {url: `/harvests`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getHarvestsControllerListQueryKey = (params?: HarvestsControllerListParams,) => {
    return [
    `/harvests`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getHarvestsControllerListQueryOptions = <TData = Awaited<ReturnType<typeof harvestsControllerList>>, TError = unknown>(params?: HarvestsControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHarvestsControllerListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof harvestsControllerList>>> = ({ signal }) => harvestsControllerList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HarvestsControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof harvestsControllerList>>>
export type HarvestsControllerListQueryError = unknown


export function useHarvestsControllerList<TData = Awaited<ReturnType<typeof harvestsControllerList>>, TError = unknown>(
 params: undefined |  HarvestsControllerListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerList>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerList<TData = Awaited<ReturnType<typeof harvestsControllerList>>, TError = unknown>(
 params?: HarvestsControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerList>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerList<TData = Awaited<ReturnType<typeof harvestsControllerList>>, TError = unknown>(
 params?: HarvestsControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List the caller's own harvests (paginated, owner-scoped)
 */

export function useHarvestsControllerList<TData = Awaited<ReturnType<typeof harvestsControllerList>>, TError = unknown>(
 params?: HarvestsControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHarvestsControllerListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Aggregates the caller's own harvests: total + counts by status, total kg, kg per quality grade (A/B/C), and a sales count + amount across sold/settled harvests. Read-only — a farmer who later joined a coop can still view their past G1 summary (no independence gate on this route).
 * @summary Owner-scoped harvest insights (counts, kg, per-grade, sales)
 */
export const harvestsControllerSummary = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<HarvestSummaryDto>(
      {url: `/harvests/summary`, method: 'GET', signal
    },
      );
    }
  



export const getHarvestsControllerSummaryQueryKey = () => {
    return [
    `/harvests/summary`
    ] as const;
    }

    
export const getHarvestsControllerSummaryQueryOptions = <TData = Awaited<ReturnType<typeof harvestsControllerSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHarvestsControllerSummaryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof harvestsControllerSummary>>> = ({ signal }) => harvestsControllerSummary(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HarvestsControllerSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof harvestsControllerSummary>>>
export type HarvestsControllerSummaryQueryError = unknown


export function useHarvestsControllerSummary<TData = Awaited<ReturnType<typeof harvestsControllerSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerSummary>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerSummary<TData = Awaited<ReturnType<typeof harvestsControllerSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerSummary>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerSummary<TData = Awaited<ReturnType<typeof harvestsControllerSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Owner-scoped harvest insights (counts, kg, per-grade, sales)
 */

export function useHarvestsControllerSummary<TData = Awaited<ReturnType<typeof harvestsControllerSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerSummary>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHarvestsControllerSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Sums the caller's settled marketplace orders (transactions, scoped to seller_user_id = caller OR a coop the caller administers) with their own recorded off-platform harvest sales (individual_harvests.sale_amount). "this month" uses date_trunc(month) on settled_at / sale_recorded_at. Money is a plain-ZAR string. Read-only — no independence gate.
 * @summary Seller earnings for the caller — this calendar month + lifetime
 */
export const harvestsControllerEarnings = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<HarvestEarningsDto>(
      {url: `/harvests/earnings`, method: 'GET', signal
    },
      );
    }
  



export const getHarvestsControllerEarningsQueryKey = () => {
    return [
    `/harvests/earnings`
    ] as const;
    }

    
export const getHarvestsControllerEarningsQueryOptions = <TData = Awaited<ReturnType<typeof harvestsControllerEarnings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerEarnings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHarvestsControllerEarningsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof harvestsControllerEarnings>>> = ({ signal }) => harvestsControllerEarnings(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerEarnings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HarvestsControllerEarningsQueryResult = NonNullable<Awaited<ReturnType<typeof harvestsControllerEarnings>>>
export type HarvestsControllerEarningsQueryError = unknown


export function useHarvestsControllerEarnings<TData = Awaited<ReturnType<typeof harvestsControllerEarnings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerEarnings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerEarnings>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerEarnings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerEarnings<TData = Awaited<ReturnType<typeof harvestsControllerEarnings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerEarnings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerEarnings>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerEarnings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerEarnings<TData = Awaited<ReturnType<typeof harvestsControllerEarnings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerEarnings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Seller earnings for the caller — this calendar month + lifetime
 */

export function useHarvestsControllerEarnings<TData = Awaited<ReturnType<typeof harvestsControllerEarnings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerEarnings>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHarvestsControllerEarningsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 404 if the harvest is missing or owned by someone else.
 * @summary Read a single owned harvest by id
 */
export const harvestsControllerGetOne = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<HarvestDto>(
      {url: `/harvests/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getHarvestsControllerGetOneQueryKey = (id?: string,) => {
    return [
    `/harvests/${id}`
    ] as const;
    }

    
export const getHarvestsControllerGetOneQueryOptions = <TData = Awaited<ReturnType<typeof harvestsControllerGetOne>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerGetOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHarvestsControllerGetOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof harvestsControllerGetOne>>> = ({ signal }) => harvestsControllerGetOne(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerGetOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HarvestsControllerGetOneQueryResult = NonNullable<Awaited<ReturnType<typeof harvestsControllerGetOne>>>
export type HarvestsControllerGetOneQueryError = unknown


export function useHarvestsControllerGetOne<TData = Awaited<ReturnType<typeof harvestsControllerGetOne>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerGetOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerGetOne>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerGetOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerGetOne<TData = Awaited<ReturnType<typeof harvestsControllerGetOne>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerGetOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerGetOne>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerGetOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerGetOne<TData = Awaited<ReturnType<typeof harvestsControllerGetOne>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerGetOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Read a single owned harvest by id
 */

export function useHarvestsControllerGetOne<TData = Awaited<ReturnType<typeof harvestsControllerGetOne>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerGetOne>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHarvestsControllerGetOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Allowed transitions: open→locked|cancelled; locked→open|sold|cancelled; sold→settled. Anything else returns 400. 404 if the harvest is not owned by the caller.
 * @summary Transition status (open|locked|sold|settled|cancelled)
 */
export const harvestsControllerPatch = (
    id: string,
    patchHarvestStatusDto: PatchHarvestStatusDto,
 ) => {
      
      
      return fseAxios<HarvestDto>(
      {url: `/harvests/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchHarvestStatusDto
    },
      );
    }
  


export const getHarvestsControllerPatchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerPatch>>, TError,{id: string;data: PatchHarvestStatusDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerPatch>>, TError,{id: string;data: PatchHarvestStatusDto}, TContext> => {

const mutationKey = ['harvestsControllerPatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof harvestsControllerPatch>>, {id: string;data: PatchHarvestStatusDto}> = (props) => {
          const {id,data} = props ?? {};

          return  harvestsControllerPatch(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HarvestsControllerPatchMutationResult = NonNullable<Awaited<ReturnType<typeof harvestsControllerPatch>>>
    export type HarvestsControllerPatchMutationBody = PatchHarvestStatusDto
    export type HarvestsControllerPatchMutationError = unknown

    /**
 * @summary Transition status (open|locked|sold|settled|cancelled)
 */
export const useHarvestsControllerPatch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerPatch>>, TError,{id: string;data: PatchHarvestStatusDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof harvestsControllerPatch>>,
        TError,
        {id: string;data: PatchHarvestStatusDto},
        TContext
      > => {

      const mutationOptions = getHarvestsControllerPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Sets locked_at = now(). Same semantics as PATCH /harvests/:id with body {status:"locked"}.
 * @summary Convenience: transition open → locked
 */
export const harvestsControllerLock = (
    id: string,
 ) => {
      
      
      return fseAxios<HarvestDto>(
      {url: `/harvests/${id}/lock`, method: 'PATCH'
    },
      );
    }
  


export const getHarvestsControllerLockMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerLock>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerLock>>, TError,{id: string}, TContext> => {

const mutationKey = ['harvestsControllerLock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof harvestsControllerLock>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  harvestsControllerLock(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HarvestsControllerLockMutationResult = NonNullable<Awaited<ReturnType<typeof harvestsControllerLock>>>
    
    export type HarvestsControllerLockMutationError = unknown

    /**
 * @summary Convenience: transition open → locked
 */
export const useHarvestsControllerLock = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerLock>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof harvestsControllerLock>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getHarvestsControllerLockMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Records the farmer's own off-platform sale of a LOCKED harvest (buyer name, amount, date, payment method) and transitions it to sold. This is NOT the marketplace: no buyer account, no listing/offer, no payment processing, and no on-chain settlement — it is a personal sales ledger only. Harvest must be status=locked (else 400) and owned by the caller (else 404).
 * @summary Record a PRIVATE off-platform sale + transition locked → sold
 */
export const harvestsControllerRecordSale = (
    id: string,
    recordSaleDto: RecordSaleDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<HarvestDto>(
      {url: `/harvests/${id}/sale`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recordSaleDto, signal
    },
      );
    }
  


export const getHarvestsControllerRecordSaleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerRecordSale>>, TError,{id: string;data: RecordSaleDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerRecordSale>>, TError,{id: string;data: RecordSaleDto}, TContext> => {

const mutationKey = ['harvestsControllerRecordSale'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof harvestsControllerRecordSale>>, {id: string;data: RecordSaleDto}> = (props) => {
          const {id,data} = props ?? {};

          return  harvestsControllerRecordSale(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HarvestsControllerRecordSaleMutationResult = NonNullable<Awaited<ReturnType<typeof harvestsControllerRecordSale>>>
    export type HarvestsControllerRecordSaleMutationBody = RecordSaleDto
    export type HarvestsControllerRecordSaleMutationError = unknown

    /**
 * @summary Record a PRIVATE off-platform sale + transition locked → sold
 */
export const useHarvestsControllerRecordSale = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerRecordSale>>, TError,{id: string;data: RecordSaleDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof harvestsControllerRecordSale>>,
        TError,
        {id: string;data: RecordSaleDto},
        TContext
      > => {

      const mutationOptions = getHarvestsControllerRecordSaleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Harvest must be status=open and owned by the caller (else 404). clientOpId enables idempotent retries from the mobile SyncEngine outbox.
 * @summary Record a contribution to an owned open harvest
 */
export const harvestsControllerAddContribution = (
    id: string,
    createHarvestContributionDto: CreateHarvestContributionDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<HarvestContributionDto>(
      {url: `/harvests/${id}/contributions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createHarvestContributionDto, signal
    },
      );
    }
  


export const getHarvestsControllerAddContributionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerAddContribution>>, TError,{id: string;data: CreateHarvestContributionDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerAddContribution>>, TError,{id: string;data: CreateHarvestContributionDto}, TContext> => {

const mutationKey = ['harvestsControllerAddContribution'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof harvestsControllerAddContribution>>, {id: string;data: CreateHarvestContributionDto}> = (props) => {
          const {id,data} = props ?? {};

          return  harvestsControllerAddContribution(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HarvestsControllerAddContributionMutationResult = NonNullable<Awaited<ReturnType<typeof harvestsControllerAddContribution>>>
    export type HarvestsControllerAddContributionMutationBody = CreateHarvestContributionDto
    export type HarvestsControllerAddContributionMutationError = unknown

    /**
 * @summary Record a contribution to an owned open harvest
 */
export const useHarvestsControllerAddContribution = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerAddContribution>>, TError,{id: string;data: CreateHarvestContributionDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof harvestsControllerAddContribution>>,
        TError,
        {id: string;data: CreateHarvestContributionDto},
        TContext
      > => {

      const mutationOptions = getHarvestsControllerAddContributionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * 404 if the harvest is not owned by the caller.
 * @summary List contributions of an owned harvest (paginated)
 */
export const harvestsControllerListContributions = (
    id: string,
    params?: HarvestsControllerListContributionsParams,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<HarvestContributionListDto>(
      {url: `/harvests/${id}/contributions`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getHarvestsControllerListContributionsQueryKey = (id?: string,
    params?: HarvestsControllerListContributionsParams,) => {
    return [
    `/harvests/${id}/contributions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getHarvestsControllerListContributionsQueryOptions = <TData = Awaited<ReturnType<typeof harvestsControllerListContributions>>, TError = unknown>(id: string,
    params?: HarvestsControllerListContributionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerListContributions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHarvestsControllerListContributionsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof harvestsControllerListContributions>>> = ({ signal }) => harvestsControllerListContributions(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerListContributions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HarvestsControllerListContributionsQueryResult = NonNullable<Awaited<ReturnType<typeof harvestsControllerListContributions>>>
export type HarvestsControllerListContributionsQueryError = unknown


export function useHarvestsControllerListContributions<TData = Awaited<ReturnType<typeof harvestsControllerListContributions>>, TError = unknown>(
 id: string,
    params: undefined |  HarvestsControllerListContributionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerListContributions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerListContributions>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerListContributions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerListContributions<TData = Awaited<ReturnType<typeof harvestsControllerListContributions>>, TError = unknown>(
 id: string,
    params?: HarvestsControllerListContributionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerListContributions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerListContributions>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerListContributions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerListContributions<TData = Awaited<ReturnType<typeof harvestsControllerListContributions>>, TError = unknown>(
 id: string,
    params?: HarvestsControllerListContributionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerListContributions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List contributions of an owned harvest (paginated)
 */

export function useHarvestsControllerListContributions<TData = Awaited<ReturnType<typeof harvestsControllerListContributions>>, TError = unknown>(
 id: string,
    params?: HarvestsControllerListContributionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerListContributions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHarvestsControllerListContributionsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One image file in the multipart field "file" (image/* only, max 5 MB). The bytes are proxied to internal MinIO; this returns the photo metadata. Harvest must be owned by the caller (else 404); a coop-affiliated farmer is blocked (403 — individual harvests are a read-only log). 400 if the upload is not an image or exceeds 5 MB.
 * @summary Upload a photo to an owned harvest (multipart/form-data)
 */
export const harvestsControllerUploadPhoto = (
    id: string,
    uploadHarvestPhotoDto: UploadHarvestPhotoDto,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, uploadHarvestPhotoDto.file)

      return fseAxios<HarvestPhotoDto>(
      {url: `/harvests/${id}/photos`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getHarvestsControllerUploadPhotoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerUploadPhoto>>, TError,{id: string;data: UploadHarvestPhotoDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerUploadPhoto>>, TError,{id: string;data: UploadHarvestPhotoDto}, TContext> => {

const mutationKey = ['harvestsControllerUploadPhoto'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof harvestsControllerUploadPhoto>>, {id: string;data: UploadHarvestPhotoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  harvestsControllerUploadPhoto(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HarvestsControllerUploadPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof harvestsControllerUploadPhoto>>>
    export type HarvestsControllerUploadPhotoMutationBody = UploadHarvestPhotoDto
    export type HarvestsControllerUploadPhotoMutationError = unknown

    /**
 * @summary Upload a photo to an owned harvest (multipart/form-data)
 */
export const useHarvestsControllerUploadPhoto = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof harvestsControllerUploadPhoto>>, TError,{id: string;data: UploadHarvestPhotoDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof harvestsControllerUploadPhoto>>,
        TError,
        {id: string;data: UploadHarvestPhotoDto},
        TContext
      > => {

      const mutationOptions = getHarvestsControllerUploadPhotoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Metadata only (id, contentType, sizeBytes, uploadedAt) — fetch the bytes via GET /harvests/:id/photos/:photoId. 404 if the harvest is not owned by the caller.
 * @summary List photo metadata for an owned harvest (newest first)
 */
export const harvestsControllerListPhotos = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<HarvestPhotoListDto>(
      {url: `/harvests/${id}/photos`, method: 'GET', signal
    },
      );
    }
  



export const getHarvestsControllerListPhotosQueryKey = (id?: string,) => {
    return [
    `/harvests/${id}/photos`
    ] as const;
    }

    
export const getHarvestsControllerListPhotosQueryOptions = <TData = Awaited<ReturnType<typeof harvestsControllerListPhotos>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerListPhotos>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHarvestsControllerListPhotosQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof harvestsControllerListPhotos>>> = ({ signal }) => harvestsControllerListPhotos(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerListPhotos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HarvestsControllerListPhotosQueryResult = NonNullable<Awaited<ReturnType<typeof harvestsControllerListPhotos>>>
export type HarvestsControllerListPhotosQueryError = unknown


export function useHarvestsControllerListPhotos<TData = Awaited<ReturnType<typeof harvestsControllerListPhotos>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerListPhotos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerListPhotos>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerListPhotos>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerListPhotos<TData = Awaited<ReturnType<typeof harvestsControllerListPhotos>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerListPhotos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerListPhotos>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerListPhotos>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerListPhotos<TData = Awaited<ReturnType<typeof harvestsControllerListPhotos>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerListPhotos>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List photo metadata for an owned harvest (newest first)
 */

export function useHarvestsControllerListPhotos<TData = Awaited<ReturnType<typeof harvestsControllerListPhotos>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerListPhotos>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHarvestsControllerListPhotosQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Proxies the image bytes from internal MinIO with the stored Content-Type. 404 if the photo is not on a harvest owned by the caller.
 * @summary Stream a single owned harvest photo (image bytes)
 */
export const harvestsControllerGetPhoto = (
    id: string,
    photoId: string,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<Blob>(
      {url: `/harvests/${id}/photos/${photoId}`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  



export const getHarvestsControllerGetPhotoQueryKey = (id?: string,
    photoId?: string,) => {
    return [
    `/harvests/${id}/photos/${photoId}`
    ] as const;
    }

    
export const getHarvestsControllerGetPhotoQueryOptions = <TData = Awaited<ReturnType<typeof harvestsControllerGetPhoto>>, TError = unknown>(id: string,
    photoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerGetPhoto>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHarvestsControllerGetPhotoQueryKey(id,photoId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof harvestsControllerGetPhoto>>> = ({ signal }) => harvestsControllerGetPhoto(id,photoId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && photoId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerGetPhoto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HarvestsControllerGetPhotoQueryResult = NonNullable<Awaited<ReturnType<typeof harvestsControllerGetPhoto>>>
export type HarvestsControllerGetPhotoQueryError = unknown


export function useHarvestsControllerGetPhoto<TData = Awaited<ReturnType<typeof harvestsControllerGetPhoto>>, TError = unknown>(
 id: string,
    photoId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerGetPhoto>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerGetPhoto>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerGetPhoto>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerGetPhoto<TData = Awaited<ReturnType<typeof harvestsControllerGetPhoto>>, TError = unknown>(
 id: string,
    photoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerGetPhoto>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof harvestsControllerGetPhoto>>,
          TError,
          Awaited<ReturnType<typeof harvestsControllerGetPhoto>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHarvestsControllerGetPhoto<TData = Awaited<ReturnType<typeof harvestsControllerGetPhoto>>, TError = unknown>(
 id: string,
    photoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerGetPhoto>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Stream a single owned harvest photo (image bytes)
 */

export function useHarvestsControllerGetPhoto<TData = Awaited<ReturnType<typeof harvestsControllerGetPhoto>>, TError = unknown>(
 id: string,
    photoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof harvestsControllerGetPhoto>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHarvestsControllerGetPhotoQueryOptions(id,photoId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




